import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { LANGUAGES } from "@/i18n";
import { Globe } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { API } from "@/App";

let _mlCache = null;

export const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [enabled, setEnabled] = useState(_mlCache === true);

  useEffect(() => {
    if (_mlCache !== null) {
      if (!_mlCache && i18n.language !== "en") i18n.changeLanguage("en");
      return;
    }
    fetch(`${API}/site-settings`).then(r => r.json()).then(d => {
      _mlCache = !!d.multilanguage_enabled;
      setEnabled(_mlCache);
      if (!_mlCache && i18n.language !== "en") i18n.changeLanguage("en");
    }).catch(() => {});
  }, [i18n]);

  if (!enabled) return null;

  const current = LANGUAGES.find((l) => l.code === i18n.language) || LANGUAGES[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className="text-white/60 hover:text-white h-8 px-2 text-xs" data-testid="lang-switcher">
          <Globe className="w-3.5 h-3.5 mr-1" />
          <span>{current.flag} {current.code.toUpperCase()}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="bg-dark-paper border-white/10 max-h-[400px] overflow-y-auto" align="end">
        {LANGUAGES.map((lang) => (
          <DropdownMenuItem
            key={lang.code}
            onClick={() => i18n.changeLanguage(lang.code)}
            className={`text-xs cursor-pointer ${i18n.language === lang.code ? "bg-purple-500/20 text-purple-300" : "text-white/70"}`}
            data-testid={`lang-${lang.code}`}
          >
            <span className="mr-2">{lang.flag}</span>
            {lang.name}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSwitcher;
